import opApiRequest from 'api/apiRequest';
import endpoints from 'api/endpoints';
import { HttpMethods } from 'api/types';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'store/index';
import fetchPricesOperation from 'store/price/operation/fetchPricesOperation';
import { setPricesToFetchAction } from 'store/price/slice';
import collectPricesFromFavourites from 'utils/price/collectPricesFromFavourites';
import removeExistingPrices from 'utils/price/removeExistingPrices';
import { setFavouriteProductsAction } from '../slice';
import { FavouriteProduct } from '../types';

const fetchFavouritesOperation =
  () => async (dispatch: ThunkDispatch<Store, undefined, AnyAction>, getState: () => Store) => {
    const store = getState();
    const data = await opApiRequest<{ favourites: FavouriteProduct[] }>(
      endpoints.favouritesGetV1,
      { useCache: false },
      HttpMethods.POST,
      'data',
    );

    if (!data || !data.favourites) {
      return;
    }

    dispatch(setFavouriteProductsAction(data.favourites));

    const pricesToFetch = removeExistingPrices(store, collectPricesFromFavourites(data.favourites));
    dispatch(setPricesToFetchAction(pricesToFetch));
    dispatch(fetchPricesOperation());
  };

export default fetchFavouritesOperation;
